var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0768 0.568908C8.87286 0.382728 8.5566 0.397126 8.37042 0.601066C8.18424 0.805006 8.19864 1.12126 8.40258 1.30744L14.5704 6.93817H0.739685C0.463543 6.93817 0.239685 7.16203 0.239685 7.43817C0.239685 7.71431 0.463543 7.93817 0.739685 7.93817H14.5675L8.40258 13.5663C8.19864 13.7524 8.18424 14.0687 8.37042 14.2726C8.5566 14.4766 8.87286 14.491 9.0768 14.3048L15.9931 7.99075C16.1331 7.86299 16.2129 7.69545 16.2326 7.52231C16.2373 7.49495 16.2397 7.46684 16.2397 7.43817C16.2397 7.4113 16.2376 7.38492 16.2335 7.3592C16.2153 7.18329 16.1352 7.01263 15.9931 6.88295L9.0768 0.568908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/RightArrowWhite.91f46253439b1f1ec3d8bc88fd76117e.svg";
export { ForwardRef as ReactComponent };